/**
 * Setup the scanner with the current anchor
 * @param anchorUrl
 */
export const Scanner = (anchorUrl) => {
    const scanner = document.querySelector('#target-image');
    scanner.style.setProperty('background-image', `url(${anchorUrl})`);
    scanner.hidden = false;
};
